import React, { forwardRef } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';

const hl = {
    pl: 'pl',
    en: 'en',
    de: 'de'
};

export const execute = async (reCaptchaRef, formType) => {
    if (!reCaptchaRef.current.props.grecaptcha) {
        return new Promise((res) => {
            reCaptchaRef.current.props.ready(async () => { res(await execute(reCaptchaRef, formType)); });
        });
    }
    return reCaptchaRef.current.props.grecaptcha.execute(formType);
};
const Recaptcha = forwardRef(({ language, ...props }, ref) => (
    <ReCAPTCHA
      size="invisible"
      sitekey={ process.env.RECAPTCHA }
      hl={ hl[language] || hl.en }
      { ...props }
      ref={ ref }
    />
));

export default Recaptcha;



// WEBPACK FOOTER //
// ./src/components/Recaptcha.jsx